import * as React from "react";

// Material UI
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

// Components
import TimerAdder from "./TimeAdder";
import SimpleCheckbox from "components/SimpleCheckbox";
import { Typography } from "@material-ui/core";

// Utils
import { strings } from "core/localizedStrings";

interface CountdownTimerOptionsProps {
    onAddSeconds: (seconds: number) => void;
}

const CountdownTimerOptions = (props: CountdownTimerOptionsProps) => {
    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            optionsContainer: {
                padding: 20,
            },
            valueTextField: {
                width: 80,
            },
            plusMins: {
                padding: 0,
                width: 30,
            },
        })
    );
    const classes = useStyles();

    const onAddMinutes = (value: number) => {
        props.onAddSeconds(value * 60);
    };

    const onAddSeconds = (value: number) => {
        props.onAddSeconds(value);
    };

    return (
        <Grid container direction="column" spacing={2} className={classes.optionsContainer}>
            <Typography variant="subtitle1">{strings.options}</Typography>
            <Grid item>
                <TimerAdder title={"Minutes"} onValueAdded={onAddMinutes} />
            </Grid>
            <Grid item>
                <TimerAdder title={"Seconds"} onValueAdded={onAddSeconds} />
            </Grid>
            <Grid item>
                <SimpleCheckbox label="Play sound on complete" isChecked={true} onChange={() => {}}></SimpleCheckbox>
            </Grid>
        </Grid>
    );
};

export default CountdownTimerOptions;
